import {
  Component,
  OnInit,
  ElementRef,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { FormError } from '../../interfaces/form-error.interface'

@Component({
  selector: 'wm-front-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class FormErrorComponent implements OnInit {
  /** The type of the error passed by the parent component */
  @Input() public error: FormError

  protected _elementRef = inject(ElementRef)

  public ngOnInit(): void {
    // classList.add throws on empty tokens, and color is optional
    this._elementRef.nativeElement.classList.add(
      ...[this.error.color, this.error.position].filter(Boolean)
    )
  }
}
